module.exports = __webpack_public_path__ + "img/solutions1.a015e3bf.png";